export default {
    Unknow: 0,
    SendMessage: 1,
    PrintTemplate: 2,
}